import React, { useEffect } from 'react'
import Navigation from '../../../Components/Navigation/Navigation'
import Footer from '../../../Components/Footer/Footer'
import Hero from './Sections/Hero/Hero'
import IndustryChallengesAndSolutions from './Sections/IndustryChallengesAndSolutions/IndustryChallengesAndSolutions'
import IndustryTech from './Sections/IndustryTech/IndustryTech'
import AISearch from './Sections/AISearch/AISearch'
import AOS from 'aos'
import 'aos/dist/aos.css'
import SpecializedServices from './Sections/SpecializedServices/SpecializedServices'
import CaseStudies from '../../Home/Components/CaseStudies'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import Contect from '../../Home/Components/Contect'
import WhyChoose from './Sections/WhyChoose/WhyChoose'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import healthcareMockup from '../../../assets/images/healthcare_mokcup.png'
import OurSolutionIcon from '../../../assets/images/our_solution.svg'
import image12 from '../../../assets/images/image12.png';
import khamba from '../../../assets/images/khamba.svg';
import image35 from '../../../assets/images/image35.png';
import frame1 from '../../../assets/images/frame2.svg';
import whyChooseHealthcare from '../../../assets/images/whychoosehealthcare.png';
import FAQ from '../../../Components/FAQ/FAQ';

const questions = [
  {
    q: "How long does it take to build a web application?",
    a: "It depends on various factors including complexity and team size."
  },
  {
    q: "Can you integrate with our existing systems (ERP/CRM)?",
    a: "Absolutely. We specialize in API development & integration, which enables smooth syncing with your existing tech ecosystem."
  }
];

const HealthCare = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 100,
        });
    }, []);

    const homeContent = {
        title: "Healthcare App Development",
        description: "At KoolMind, we don’t just code apps; we forge tools that turn patient hassles into raving loyalty and supercharge your team’s efficiency. From effective mobile apps patients adore to web platforms that lighten your staff’s load, we deliver breakthroughs that hit your bottom line hard.",
        image: healthcareMockup,
        breadcrumb: "Healthcare",
        b: "Book a Free Consultation Now"
    }

    const industryChallengesAndSolutionsContent = {
        challengesTitle: "Industry Challenges",
        solutionsTitle: "Our Solutions",
        challenges: [
            {
                title: 'Safeguarding Sensitive Data',
                description: 'One data breach could cost you thousands per record and shatter your trust overnight. With cyber threats surging, your current defenses might be a liability waiting to explode.',
                icon: '/images/industries/healthcare/00.svg',
            },
            {
                title: 'Revamping Outdated Tech',
                description: 'Those clunky old systems aren’t just slow, they’re draining your staff’s energy and driving patients away with every delay.',
                icon: '/images/industries/healthcare/01.svg',
            },
            {
                title: 'Connecting with Patients',
                description: 'If your digital tools feel stuck in the past, you’re losing patients, many switch providers over outdated experiences that frustrate them.',
                icon: '/images/industries/healthcare/02.svg',
            },
            {
                title: 'Reaching Remote Rural Areas',
                description: 'Limited connectivity leaves rural patients stranded, forcing dangerous delays in care and driving them to distant competitors when local access fails.',
                icon: '/images/industries/healthcare/03.svg',
            },
            {
                title: 'Unifying Disjointed Systems',
                description: 'Scattered platforms create chaos, risking patient safety and exposing you to costly errors when critical info gets lost.',
                icon: '/images/industries/healthcare/04.svg',
            },
        ],
        solutions: [
            {
                title: 'Unbreakable Security Systems',
                description: 'We deploy cutting-edge encryption and relentless security tests, turning your data into an impenetrable fortress your patients can trust.',
                icon: '/images/industries/healthcare/05.svg',
            },
            {
                title: 'Smart System Revamps',
                description: 'Our pros don’t just link old and new tech, they craft smooth transitions that preserve your investments and unlock modern power.',
                icon: '/images/industries/healthcare/06.svg',
            },
            {
                title: 'Delightful Patient Tools',
                description: 'We build interfaces so simple that anyone can navigate them, turning patients into fans who bring their friends your way.',
                icon: '/images/industries/healthcare/07.svg',
            },
            {
                title: 'Rural Care Bridge',
                description: 'Our tech doesn\'t just work in high-coverage areas, we engineer solutions that thrive on weak signals and connect remote patients to quality care without barriers.',
                icon: '/images/industries/healthcare/08.svg',
            },
            {
                title: 'Flawless System Sync',
                description: 'Our expertise weaves your platforms into a single, reliable hub where data flows perfectly, right when you need it.',
                icon: '/images/industries/healthcare/09.svg',
            }
        ]
    }

    const industryTechContent = {
        mainTitle: 'Advanced Technologies to Build Healthcare Industry Software',
        leftHeading: 'Harnessing Advanced Technologies For Healthcare Software Development',
        leftParagraph: 'We believe that weaving in cutting-edge tech unlocks a new era of patient care and efficiency. Our approach crafts robust, future-ready software that keeps you ahead.',
        leftImage: image12,
        performanceItems: [
            {
                title: 'Artificial Intelligence',
                description: 'Smart AI transforms diagnostics, learning from each case to predict health needs with precision.',
                icon: '/images/industries/healthcare/09.svg',
            },
            {
                title: 'Cloud Computing',
                description: 'Scalable clouds adapt to your demand, offering secure storage and access without the hassle.',
                icon: '/images/industries/healthcare/010.svg',
            },
            {
                title: 'Internet of Things (IoT)',
                description: 'IoT devices provide real-time patient monitoring, connecting care directly to your fingertips.',
                icon: '/images/industries/healthcare/011.svg',
            }
        ]
    };

    const aiSearchContent = {
        mainTitle: 'Explore Our Comprehensive Digital Healthcare Solutions',
        sections: [
            {
                title: 'AI-Powered Visual and Voice Search',
                description: 'When patients can find what they need in seconds instead of minutes, they stop calling your overloaded staff and start becoming your biggest advocates.',
                image: '/images/industries/healthcare/ai-powered.png',
                imageAlt: 'AI-Powered Healthcare Search Interface',
                imagePosition: 'left',
                features: [
                    'Upload prescription photos for instant medication matching and availability alerts',
                    'Voice search that understands "chest pain" just as clearly as "acute myocardial infarction"',
                    'Intuitive navigation that cuts your support calls in half while improving patient satisfaction',
                    'Personalized health recommendations that turn routine visits into preventive care opportunities',
                    'Live inventory tracking that eliminates the frustration of unavailable medications',
                    'Search experience so smooth that patients prefer your digital tools over competitor alternatives',
                ],
            },
            {
                title: 'Virtual Health Assistant',
                description: 'Your patients need answers at 2 AM when symptoms worry them most. Our AI assistant provides professional guidance around the clock, reducing unnecessary ER visits while building patient confidence.',
                image: '/images/industries/healthcare/virtual-health.png',
                imageAlt: 'Virtual Health Assistant',
                imagePosition: 'right',
                features: [
                    'Intelligent symptom assessment that knows when to recommend immediate care versus self-monitoring',
                    'Customized care plans that adapt based on patient response and medical history',
                    'Automated medication and appointment reminders that improve compliance by 75%',
                    'Multilingual support that serves diverse patient populations without language barriers',
                    'Wellness goal tracking with real-time feedback that keeps patients motivated',
                    'Proactive health education that positions your practice as a trusted wellness partner',
                ],
            },
            {
                title: 'Telemedicine Integration Hub',
                description: 'Remote care isn\'t the future, it\'s today\'s competitive requirement. Our platform makes virtual consultations feel as personal and professional as in-office visits.',
                image: '/images/industries/healthcare/telemedicine-integration.png',
                imageAlt: 'Telemedicine Integration Hub',
                imagePosition: 'left',
                features: [
                    'One-click scheduling that eliminates phone tag between patients and staff',
                    'Secure medical record sharing that gives providers complete patient context during consultations',
                    'HD video quality that enables accurate visual assessments and builds patient trust',
                    'Electronic prescriptions sent directly to preferred pharmacies, streamlining the medication process',
                    'Wearable device integration that provides real-time vital signs during virtual visits',
                    'Seamless user experience that makes patients choose virtual visits over driving to competitors',
                ],
            },
            {
                title: 'Smart Appointment Management',
                description: 'No-shows cost the average practice hundreds of dollars per missed appointment. Our intelligent system turns scheduling chaos into predictable revenue streams.',
                image: '/images/industries/healthcare/smart-appointment.png',
                imageAlt: 'Smart Appointment Management',
                imagePosition: 'right',
                features: [
                    '24/7 online booking that lets you make appointments when your competitors\' offices are closed',
                    'Automated reminder sequences that reduce no-shows by up to 80%',
                    'AI-powered scheduling that makes providers work as efficiently as possible and cuts down on wait times for patients',
                    'Follow-up questionnaires that get input from patients while they still recall what happened',
                    'Calendar integration that keeps providers\' personal and professional schedules synchronized',
                    'Optimized appointment flow that increases daily patient capacity without extending hours',
                ],
            },
            {
                title: 'Real-Time Health Monitoring Dashboard',
                description: 'When you can see health changes before patients experience them, you go from treating problems after they happen to preventing them before they happen, and patients realize the difference.',
                image: '/images/industries/healthcare/real-time.png',
                imageAlt: 'Real-Time Health Monitoring Dashboard',
                imagePosition: 'left',
                features: [
                    'Constantly checking vital signs to spot worrying trends before they turn into emergencies',
                    'Immediate alerts for important developments that let you act right away',
                    'Visual progress tracking that shows patients their improvement and motivates continued care',
                    'Transparent health updates that build trust and encourage patient engagement',
                    'IoT device integration that captures comprehensive health data without manual input',
                    'Actionable insights that guide treatment decisions with real-time accuracy',
                ],
            },
            {
                title: 'Mental wellness apps',
                description: 'Your patients’ minds deserve care as much as their bodies do. Our mental wellness apps ease stress, lift moods, and put practical help right in their pockets, keeping them healthier and more loyal to your practice.',
                image: '/images/industries/healthcare/mental.png',
                imageAlt: 'Mental wellness apps',
                imagePosition: 'right',
                features: [
                    'Guided meditation and stress relief exercises available anytime',
                    'Mood tracking tools that spot early warning signs and suggest support',
                    'Secure chat with licensed therapists for quick, stigma-free help',
                    'Personalized self-care plans that adapt to each user’s needs',
                    'Push notifications that gently remind patients to check in on their mental health',
                    'Data insights that help you provide better overall care',
                ],
            },
        ],
    };

    const servicesContent = {
        title: 'Our Specialized Services',
        cards: [
            {
                icon: '/images/industries/healthcare/012.svg',
                title: 'AI and Machine Learning',
                description: 'Tailored algorithms that adapt to your workflow, sharpening diagnostics and scheduling like magic.',
                buttonText: 'Discover More',
            },
            {
                icon: '/images/industries/healthcare/013.svg',
                title: 'HIPAA Compliant Apps',
                description: 'Privacy-first development that meets every regulation, protecting patient data while delivering seamless experiences.',
                buttonText: 'Discover More',
            },
            {
                icon: '/images/industries/healthcare/014.svg',
                title: 'Telemedicine Platforms',
                description: 'Video care that’s a breeze, with built-in scheduling and records for a flawless virtual visit.',
                buttonText: 'Discover More',
            },
            {
                icon: '/images/industries/healthcare/015.svg',
                title: 'Data Analytics',
                description: 'Turn your data into gold with insights that cut costs and boost patient outcomes.',
                buttonText: 'Discover More',
            },
            {
                icon: '/images/industries/healthcare/016.svg',
                title: 'Custom App Development',
                description: 'Apps designed around your process, not forcing you into a one-size-fits-all mold.',
                buttonText: 'Discover More',
            },
        ],
    };

    const whyChooseContent = {
        title: 'Why Choose Us for Healthcare IT Solutions',
        image: whyChooseHealthcare,
        imageAlt: 'Why Choose Us for Healthcare IT Solutions',
        items: [
            {
                title: 'Proven Expertise',
                desc: 'Over a decade mastering healthcare tech to solve your toughest issues.',
            },
            {
                title: 'Tailored Fit',
                desc: 'Solutions sculpted to your practice’s unique rhythm, not generic fixes.',
            },
            {
                title: 'Rock-Solid Trust',
                desc: 'Compliance is our foundation, woven into every solution we build.',
            },
            {
                title: 'Future-Ready Growth',
                desc: 'Tech that expands with your success, never holding you back.',
            },
            {
                title: 'Always On',
                desc: 'A support crew with healthcare know-how, there when downtime hits.',
            },
        ],
    };

    const faqContent = {
        title: "Got Questions? We've Got Answers",
        questions: [
            {
                q: "How does KoolMind boost my healthcare tech?",
                a: "We blend AI, cloud power, cybersecurity, telemedicine, analytics, and custom apps to outpace your challenges."
            },
            {
                q: "Can you lock down my patient data?",
                a: "You bet, we use top-grade encryption, audits, and compliance to keep your info bulletproof."
            },
            {
                q: "What about my old systems?",
                a: "We’re pros at modernizing them with smart bridges, saving your data and boosting efficiency."
            },
            {
                q: "How quick can we kick off?",
                a: "Chat with us in 48 hours, and see results rolling in within 30-60 days, let’s start!"
            }
        ]
    };

    return (
        <>
            <Navigation offer={true} />
            <Hero homeContent={homeContent} />
            <div data-aos="fade-up">
                <IndustryChallengesAndSolutions industryChallengesAndSolutionsContent={industryChallengesAndSolutionsContent} />
            </div>
            <div data-aos="fade-up">
                <IndustryTech industryTechContent={industryTechContent} />
            </div>
            <div data-aos="fade-up">
                <AISearch aiSearchContent={aiSearchContent} />
            </div>
            <div data-aos="fade-up">
                <SpecializedServices servicesContent={servicesContent} />
            </div>
            <div data-aos="fade-up">
                <WhyChoose whyChooseContent={whyChooseContent} />
            </div>
            <div data-aos="fade-up">
                <FAQ faqContent={faqContent} />
            </div>
            <div data-aos="fade-up">
                <CaseStudies />
            </div>
            <div data-aos="fade-up">
                <ClientSpeak />
            </div>
            <div data-aos="fade-up">
                <GetQuote />
            </div>
            <div data-aos="fade-up">
                <Contect />
            </div>
            <FAQ faqContent={faqContent} />
            <Footer />
        </>
    )
}

export default HealthCare
